export class Item {
  id: number;
  descricao: string;
}
